import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

import App from '../../../assets/js/app';
import DetectController from '../../../assets/js/controllers/detect';

gsap.registerPlugin(SplitText);

export default class HeroNewsDetail {

	static selector = 'hero-news-detail';

	isDesktop;

	el = {};

	splitLines;

	timelineShow;

	constructor(container) {
		this.el = {
			container,
			heading: container.querySelector(`.${this.constructor.selector}__content .content-block__heading`),
			eyebrow: container.querySelector(`.${this.constructor.selector}__content .content-block__eyebrow`),
			byline: container.querySelector(`.${this.constructor.selector}__content .content-block__byline`),
			scroll: container.querySelector(`.${this.constructor.selector}__scroll figure`),
			back: container.querySelector(`.${this.constructor.selector}__back`),
			image: container.querySelector(`.${this.constructor.selector}__image`)
		};

		this.isDesktop = DetectController.isDesktop;

		if (this.isDesktop) {
			this.splitLines = new SplitText(this.el.heading, {
				type: 'lines'
			});

			this.splitLines = new SplitText(this.splitLines.lines, {
				type: 'lines'
			});

			this.addEventListeners();
		}
	}

	addEventListeners() {
		App.on('preloadComplete', this.#onPreloadComplete);
		App.on('pageTransition', this.#onPageTransition);
		App.on('pageTransitionNext', this.#onPageTransitionNext);
	}

	removeEventListeners() {
		App.off('preloadComplete', this.#onPreloadComplete);
		App.off('pageTransition', this.#onPageTransition);
		App.off('pageTransitionNext', this.#onPageTransitionNext);
	}

	#onPreloadComplete = () => {
		this.show(true);
	};

	#onPageTransition = () => {
		this.show();
	};

	#onPageTransitionNext = () => {
		this.isNextNewsDetail = true;
		this.show();
	};

	show(delay = false) {
		this.timelineShow = gsap.timeline();
		this.timelineShow
			.fromTo(this.splitLines.lines, {
				y: '102%'
			}, {
				ease: delay ? 'expo.inOut' : 'expo.out',
				duration: 1.5,
				stagger: 0.1,
				delay: delay ? 0.5 : 0,
				y: '0%'
			}, 'start')
			.fromTo([this.el.back, this.el.eyebrow, this.el.byline, this.el.scroll], {
				autoAlpha: 0
			}, {
				ease: 'power2.out',
				autoAlpha: 1,
				delay: delay ? 1 : 0,
				duration: 0.5
			}, 'start+=0.25');

		if (!this.isNextNewsDetail) {
			this.timelineShow
				.fromTo(this.el.image, {
					y: 50,
					autoAlpha: 0
				}, {
					ease: 'power2.out',
					autoAlpha: 1,
					y: 0,
					delay: delay ? 1.25 : 0.25,
					duration: 0.75
				}, 'start');
		}
	}

	destroy() {
		this.removeEventListeners();
	}

}
